 <div class="container-login100">
  <div class="wrap-login100 p-l-55 p-r-55 p-t-65 p-b-54">
    <form class="login100-form validate-form"  [formGroup]="checkoutForm" (ngSubmit)="onSubmit(checkoutForm.value)" >
      <span class="login100-form-title p-b-49">登录</span>
          <nz-alert *ngIf="error" [nzType]="'error'" [nzMessage]="error" [nzShowIcon]="true" class="mb-lg"></nz-alert> 

      <div class="wrap-input100 validate-input m-b-23" data-validate="请输入手机号">
        <span class="label-input100">手机号</span>
        <input class="input100" type="text" formControlName="userName" placeholder="请输入手机号" autocomplete="off">
        <span class="focus-input100" data-symbol=""></span>

      </div>

      <div class="wrap-input100 validate-input" data-validate="请输入密码">
        <span class="label-input100">密码</span>
        <input class="input100" type="password" formControlName="password" placeholder="请输入密码">
        <span class="focus-input100" data-symbol=""></span>

      </div>

      <div class="text-right p-t-8 p-b-31">
        <a routerLink='../forgetpassword'>忘记密码？</a>
      </div>

      <div class="container-login100-form-btn">
        <div class="wrap-login100-form-btn">
          <div class="login100-form-bgbtn"></div>

          <button  nz-button type="submit" nzType="primary"  class="login100-form-btn" [nzLoading]="http.loading">登 录</button>
        </div>
      </div>
      <div class="flex-col-c p-t-25">
        <input type="button" />
        <a href="javascript:" class="txt2">立即注册</a>
      </div>
    </form>
  </div>
</div>
